import React from 'react';
import { LanguageSelector } from '@plone/volto/components';
import config from '@plone/volto/registry';

export const MobileToolsFooter = () => {
  const { settings } = config;
  const headerConfig = {
    showLanguageSelector: true,
    ...settings.headerConfig,
  };

  if (!headerConfig.showLanguageSelector || !settings.isMultilingual) {
    return null;
  }

  return (
    <ul className="mobile-tools">
      <li>
        <LanguageSelector fullLabel={true} />
      </li>
    </ul>
  );
};
